export default __webpack_public_path__ + "static/media/champion_thumbnail.e7a9a581.png";